<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">

        <collections-form :collection="collection" :loader="loader" @click="storeCollection(collection)"
                          :showLabels="false"></collections-form>

      </div>
    </div>
  </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import collectionsApi from '../../api/collections'
  import collectionsForm from './CollectionsForm.vue'
  import Collection from '../../models/collection'

  export default {

    components: {
      collectionsForm
    },
    data () {
      return {
        collection: new Collection(),
        loader: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Inserisci nuova raccolta',
        createButton: {display: false}
      })
    },

    methods: {
      storeCollection (collection) {
        this.loader = true
        collectionsApi.store(collection)
          .then((response) => {
            toastr.success('La raccolta è stata inserita correttamente')
            this.$router.push('/collections/' + response.data.data.id)
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/collections/CollectionsCreate.vue